import React, { useState } from 'react';
import './projects.css';
import movieposterizeimg from '../../assets/images/projects/movieposterize.png';
import evolveupImg from '../../assets/images/projects/evolveupimg.png';
import cosmicdustImg from '../../assets/images/projects/cosmicdust.jpg';
import newvitalitychriopraktikImg from '../../assets/images/projects/newvitalitychriopraktik.png';
import morphmeupimg from '../../assets/images/projects/morphmeup.png';


const Projects = () => {
  const [filter, setFilter] = useState('all');

  // Project data
  const projects = [
    {
      id: 1,
      title: 'Morph Me Up',
      description: "I designed and built Morph Me Up, an AI-powered image transformation platform that enables users to generate and customize creative visuals through a smooth and intuitive interface. Developed using React, TypeScript, Tailwind CSS, and Firebase, the application combines a modern frontend with a scalable serverless architecture to support authentication, image uploads, and AI-driven processing. From the product design to the full implementation, the entire platform was created by me, while using Cursor as my development environment to help speed up workflows and streamline the build process.",
      category: ['react', 'Firebase', 'Generative AI', 'ai'],
      image: morphmeupimg,
      tags: ['React', 'TypeScript', 'Firebase', 'Tailwind CSS', 'Generative AI', 'Cursor'],
      link: 'https://morphmeup.com',
    },
    {
      id: 2,
      title: 'New Vitality Chiropraktik',
      description: "I developed the website for New Vitality Chiropraktik using WordPress, customizing a template to align with the client's vision while integrating various plugins to enhance functionality. The site features multilingual support, ensuring accessibility for a diverse audience. By refining the design and optimizing performance, I created a professional and user-friendly platform that effectively showcases the clinic's services, values, and expertise in chiropractic care.",
      category: ['wordpress', 'uiux'],
      image: newvitalitychriopraktikImg,
      tags: ['WordPress', 'UI/UX', 'Plugin Integrations', 'Google Maps API'],
      link: 'https://newvitalityleipzig.de/',
    },
    {
      id: 3,
      title: 'Cosmic Dust',
      description: "I built Cosmic Dust, an eCommerce store, using WordPress, tailoring the site to reflect the founder's vision. From customizing the design to optimizing functionality, I ensured a seamless shopping experience while maintaining a visually engaging and brand-aligned aesthetic. I also provide ongoing support, ensuring smooth performance, updates, and enhancements as the store evolves.",
      category: ['wordpress', 'E-Commerce', 'Technical Support', 'UI/UX'],
      image: cosmicdustImg,
      tags: ['wordpress', 'ecommerce', 'css', 'ui'],
      link: 'https://cosmicdust.in/',
    },
    {
      id: 4,
      title: 'Movie Posterize',
      description: "Movie Posterize is an AI-powered web application that I designed and developed from scratch, allowing users to generate cinematic movie-style posters from their images. Built using HTML, CSS, JavaScript, Vite, and Firebase, the platform combines a fast, lightweight frontend with a scalable serverless backend to support authentication, AI-powered image generation, storage, and payment features. From the product design to the complete development process, every part of the platform was created by me, with Claude Code used as part of the workflow to help fast-track development.",
      category: ['Firebase', 'Generative AI', 'javascript', 'ai', 'uiux'],
      image: movieposterizeimg,
      tags: ['JavaScript', 'Vite', 'Firebase', 'Generative AI', 'UI/UX', 'Claude Code'],
      link: 'https://movieposterize.website',
    },
    {
      id: 5,
      title: 'Evolve Up Gym',
      description: "I designed and built Evolve Up, a premium fitness brand website that reimagines the gym as a luxury, technology-driven members club rather than a traditional training space. Developed with React, TypeScript, TanStack Start, Tailwind CSS, and Firebase, the site combines cinematic UI, scroll-driven motion, and a custom admin CMS for blogs, pricing, media, and contact details. From the product design to the full implementation, the entire platform was created by me, while using Cursor as my development environment to help speed up workflows and streamline the build process.",
      category: ['react', 'uiux', 'ai'],
      image: evolveupImg,
      tags: ['React', 'TypeScript', 'TanStack Start', 'Tailwind CSS', 'Firebase', 'UI/UX', 'Cursor'],
      link: 'https://evolveupgym.richardfernando.com',
    }
  ];

  // Filter projects based on selected category
  const filteredProjects = filter === 'all'
    ? projects
    : projects.filter(project => project.category.includes(filter));

  const handleFilterChange = (newFilter) => {
    setFilter(newFilter);
  };

  return (
    <section id="projects">
      <div className="container">
        <div className="center-wrapper">
          <h2 className="section-title">My Projects</h2>
          <p className="section-subtitle">
            Explore some of my recent work that showcases my skills and expertise in web development, AI integration, and no-code solutions.
          </p>
        </div>

        <div className="projects-filter">
          <button
            className={`filter-button ${filter === 'all' ? 'active' : ''}`}
            onClick={() => handleFilterChange('all')}
          >
            All Projects
          </button>
          <button
            className={`filter-button ${filter === 'react' ? 'active' : ''}`}
            onClick={() => handleFilterChange('react')}
          >
            React
          </button>
          <button
            className={`filter-button ${filter === 'ai' ? 'active' : ''}`}
            onClick={() => handleFilterChange('ai')}
          >
            AI
          </button>
          <button
            className={`filter-button ${filter === 'wordpress' ? 'active' : ''}`}
            onClick={() => handleFilterChange('wordpress')}
          >
            WordPress
          </button>
          <button
            className={`filter-button ${filter === 'javascript' ? 'active' : ''}`}
            onClick={() => handleFilterChange('javascript')}
          >
            Javascript
          </button>
          <button
            className={`filter-button ${filter === 'uiux' ? 'active' : ''}`}
            onClick={() => handleFilterChange('uiux')}
          >
            UI/UX
          </button>
        </div>

        <div className="projects-grid">
          {filteredProjects.map(project => (
            <div
              key={project.id}
              className="project-card"
              data-category={project.category.join(',')}
            >
              <div className="project-image">
                <img src={project.image} alt={project.title} />
                <div className="project-overlay">
                  <div className="project-links">
                    <a href={project.link} className="project-link" title="View Live" target="_blank" rel="noopener noreferrer">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                        <polyline points="15 3 21 3 21 9"></polyline>
                        <line x1="10" y1="14" x2="21" y2="3"></line>
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
              <div className="project-content">
                <h3 className="project-title">{project.title}</h3>
                <p className="project-description">{project.description}</p>
                <div className="project-tags">
                  {project.tags.map((tag, index) => (
                    <span key={index} className="project-tag">{tag}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;